import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { styled, css } from 'styled-components';
import { Flex } from '@fabric-app/ui/components/Flex';
import { P } from '@fabric-app/ui/components/Typography';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { IconPath16FabricFace } from '@fabric-app/icons/svg';
import { Link } from '@fabric-app/compat';
import { cssTextEllipsis } from '@fabric-app/ui/constants/styled-utils';

const PathContainer = styled(Flex).attrs({
  alignItems: "center"
}).withConfig({
  displayName: "ResourcePath__PathContainer",
  componentId: "sc-bcc649f5-0"
})([
  `gap:0.5rem;overflow:hidden;`
]);
const NodeIconPathContainer = styled(Flex).attrs({
  alignItems: "center",
  gap: "elementsContainer"
}).withConfig({
  displayName: "ResourcePath__NodeIconPathContainer",
  componentId: "sc-bcc649f5-1"
})([
  `font-size:1rem;height:1.25rem;width:1rem;line-height:1rem;`
]);
const NodePathName = styled(P).attrs((props) => {
  return {
    ellipsis: true,
    as: "span",
    weight: 500,
    color: "tertiary",
    size: "sm",
    "data-path-item": true,
    draggable: false,
    ...props
  };
}).withConfig({
  displayName: "ResourcePath__NodePathName",
  componentId: "sc-bcc649f5-2"
})([
  `white-space:nowrap;display:flex;align-items:center;gap:0.5rem;`,
  ` &:is(a){&:hover{color:`,
  `;}}`
], ({ hasHoverState }) => hasHoverState && css([
  `&:hover{cursor:pointer;color:`,
  `;}`
], cssVar["color-text-primary"]), cssVar["color-text-primary"]);
const defaultPath = [];
const defaultShouldRenderPathItem = (item, index, pathLength) => {
  return index === 0 || index === pathLength - 1;
};
const ResourcePath = ({ path, className, showFabricRoot = true, color = "tertiary", startElement, showLeadingDivider, children, shouldRenderPathItem = defaultShouldRenderPathItem }) => {
  const renderedPath = path || defaultPath;
  return /* @__PURE__ */ jsxs(PathContainer, {
    className,
    children: [
      renderedPath.length > 0 && showFabricRoot && (startElement || /* @__PURE__ */ jsx(IconPath16FabricFace, {
        style: {
          color: cssVar["color-text-tertiary"]
        }
      })),
      renderedPath.map((node, index) => {
        if ("render" in node) {
          return /* @__PURE__ */ jsxs(React__default.Fragment, {
            children: [
              (index > 0 || showFabricRoot || showLeadingDivider) && /* @__PURE__ */ jsx(PathDivider, {}),
              node.render(index, renderedPath.length)
            ]
          }, node.id);
        }
        const title = "title" in node ? node.title : node.name;
        const linkProps = node.href ? {
          href: node.href,
          as: Link
        } : {};
        const compacted = !shouldRenderPathItem(node, index, renderedPath.length);
        return /* @__PURE__ */ jsxs(React__default.Fragment, {
          children: [
            (index > 0 || showFabricRoot || showLeadingDivider) && /* @__PURE__ */ jsx(PathDivider, {}),
            /* @__PURE__ */ jsxs(NodePathName, {
              hasHoverState: !!node.onClick || !!node.href,
              color,
              ...linkProps,
              onClick: node.onClick,
              "data-compacted": compacted,
              children: [
                node.icon && /* @__PURE__ */ jsx(NodeIconPathContainer, {
                  children: node.icon
                }),
                /* @__PURE__ */ jsx(NodePathContent, {
                  children: compacted ? "..." : title
                })
              ]
            })
          ]
        }, node.id);
      }),
      children
    ]
  });
};
const PathDivider = styled(P).attrs({
  color: "tertiary",
  children: "/",
  as: "span",
  weight: 500,
  size: "sm",
  ...{
    "data-divider": true
  }
}).withConfig({
  displayName: "ResourcePath__PathDivider",
  componentId: "sc-bcc649f5-3"
})([
  `opacity:0.5;`
]);
const NodePathContent = styled.div.withConfig({
  displayName: "ResourcePath__NodePathContent",
  componentId: "sc-bcc649f5-4"
})([
  ``,
  ``
], cssTextEllipsis);

export { NodePathName, PathDivider, ResourcePath };
//# sourceMappingURL=ResourcePath.js.map
